import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';

const SummaryRow = ({ name, value }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "200px 1fr 120px",
      px: 2,
      py: 1,
      borderBottom: "1px solid #eee",
      fontSize: 14,
    }}
  >
    <Box>{name}</Box>
    <Box sx={{ textAlign: "right" }}>{value}</Box>
  </Box>
);

const SummarySection = ({ title, rows }) => {
  // Normalise input so we never call .length on null/undefined
  const safeRows = Array.isArray(rows) ? rows : [];

  if (safeRows.length === 0) return null;

  return (
    <Box sx={{ border: "1px solid #ddd", borderRadius: 1, mb: 3 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "200px 1fr 120px",
          alignItems: "center",
          px: 2,
          py: 1,
          fontSize: 18,
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #e0e0e0",
          fontWeight: 600,
        }}
      >
        <Box sx={{ whiteSpace: "nowrap" }}>{title}</Box>
      </Box>

      {safeRows.map((r, index) => (
        <Box
          key={`${title}-${r.product_id}-${index}`}
          sx={{
            display: "grid",
            gridTemplateColumns: "200px 1fr 120px",
            alignItems: "center",
            px: 2,
            py: 1,
            fontSize: 14,
            backgroundColor: "white",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Box>{`${r.product_catalog_name}, ${r.product_name}`}</Box>
          <Box sx={{ textAlign: "right" }}>{r.total_amount}</Box>
        </Box>
      ))}
    </Box>
  );
};


const FinishedProjectSection = ({ title, rows }) => {
  const safeRows = Array.isArray(rows) ? rows : [];

  if (safeRows.length === 0) return null;

  // example: if you group by date
  const grouped = safeRows.reduce((acc, r) => {
    const key = r.expected_date
      ? r.expected_date.slice(0,10)//dayjs(r.expected_date).format("YYYY-MM-DD")
      : "未知日期";
    if (!acc[key]) acc[key] = [];
    acc[key].push(r);
    return acc;
  }, {});

  return (
    <Box sx={{ border: "1px solid #ddd", borderRadius: 1, mb: 3 }}>
      {/* header */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "200px 1fr 120px",
          alignItems: "center",
          px: 2,
          py: 1,
          fontSize: 18,
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #e0e0e0",
          fontWeight: 600,
        }}
      >
        <Box sx={{ whiteSpace: "nowrap" }}>{title}</Box>
      </Box>

      {/* rows grouped by date */}
      {Object.entries(grouped).map(([date, items]) =>
        items.map((r, index) => (
          <Box
            key={`${date}-${r.product_id}-${index}`}
            sx={{
              display: "grid",
              gridTemplateColumns: "200px 1fr 120px",
              alignItems: "center",
              px: 2,
              py: 1,
              fontSize: 14,
              backgroundColor: "white",
              borderTop: index === 0 ? "1px solid #e0e0e0" : "",
              fontWeight: 400,
            }}
          >
            <Box sx={{ whiteSpace: "nowrap" }}>{index === 0 ? date : ""}</Box>
            <Box>{r.product_catalog_name}, {r.product_name}</Box>
            <Box sx={{ textAlign: "right" }}>{r.total_amount}</Box>
          </Box>
        ))
      )}
    </Box>
  );
};


export function TransfersSummaryPanel({
  summary,
  transferTypeLabels,
  filterSite,
  transferFromSummary,
  transferToSummary,
  finishedProjectByDate,
}) {
  const summaryByType = summary.reduce((acc, r) => {
    const type = r.transfer_type || "other";
    if (!acc[type]) acc[type] = [];
    acc[type].push(r);
    return acc;
  }, {});

  return (
    <>
      <Typography variant="h5" sx={{ ml: 1, mt: 4 }}>
        小結
      </Typography>

      <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap", mt: 2 }}>
        {Object.entries(summaryByType).map(([type, rows]) => (
          <SummarySection
            key={type}
            title={transferTypeLabels[type] || type}
            rows={rows}
          />
        ))}

        {filterSite && (
          <>
            <FinishedProjectSection
              title="此地盤盤點（按日期）"
              rows={finishedProjectByDate || []}
            />

            <SummarySection
              title="從此地盤轉出"
              rows={transferFromSummary}
            />
            <SummarySection
              title="到此地盤轉入"
              rows={transferToSummary}
            />
          </>
        )}
      </Box>
    </>
  );
}
